// extracted by mini-css-extract-plugin
export default {"root":"OrganizerSettings_root__iaOjF"};